var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VideoJsPlayer',{attrs:{"sourceUrl":_vm.source,"autoplay":_vm.autoplay,"type":`video/mp4`}})
}
var staticRenderFns = []

export { render, staticRenderFns }